var map = {
	"./en-tutorial-color-drops.mp4": 22938,
	"./en-tutorial-fishgame.mp4": 96336,
	"./en-tutorial-flakesrace.mp4": 62184,
	"./en-tutorial-memorybox.mp4": 66957,
	"./en-tutorial-numberquiz.mp4": 76963,
	"./en-tutoriel-memofun.mp4": 29593,
	"./fr-tutorial-color-drops.mp4": 12653,
	"./fr-tutorial-fishgame.mp4": 78456,
	"./fr-tutorial-flakesrace.mp4": 94778,
	"./fr-tutorial-memorybox.mp4": 45949,
	"./fr-tutorial-numberquiz.mp4": 75372,
	"./fr-tutoriel-memofun.mp4": 34721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41425;